<template>
  <!-- NOTE: KB shortcuts for changing the day are built-in, but custom shortcuts were added
    because the built-in shortcuts had to be disabled in free-key mode (shortcuts for changing
    month and year are not built-in and were added as well). -->
  <!-- NOTE: The input type is "text" rather than "date" because the latter will
    activate the built-in browser datepicker in modern browsers. We don't want this
    because a) we need to support older browsers and b) a custom control offers a
    better and more consistent UX than the available built-in controls at this time. -->
  <input type="text"
    @keydown.pgUp.exact.prevent="$parent.shiftMonth(1)"
    @keydown.pgDn.exact.prevent="$parent.shiftMonth(-1)"
    @keydown.shift.pgUp.exact.prevent="$parent.shiftYear(1)"
    @keydown.shift.pgDn.exact.prevent="$parent.shiftYear(-1)"
    @keydown.up.prevent="$parent.allowFreeKey && $parent.shiftWeek(-1)"
    @keydown.down.prevent="$parent.allowFreeKey && $parent.shiftWeek(1)"
    @keydown.left.prevent="$parent.allowFreeKey && $parent.shiftDay(-1)"
    @keydown.right.prevent="$parent.allowFreeKey && $parent.shiftDay(1)"
    @keyup.delete="$parent.handleDelete"
    :aria-describedby="`${$parent.descriptionId} ${$attrs['aria-describedby'] || ''}`"
    autocomplete="off"
    v-bind="$attrs"
    :readonly="$attrs.readonly || !$parent.allowFreeKey"
    v-focus="$parent.hasFocus"
  />
</template>

<script>
import Vue from 'vue';
import { pgDn, pgUp } from '../../../util/keyCodes';
import focus from '../../../directives/focus';

Vue.config.keyCodes = {
  ...Vue.config.keyCodes,
  pgDn,
  pgUp
};

export default {
  name: 'date-picker-input',

  inheritAttrs: false,

  directives: { focus }
};
</script>
